import i18n from 'i18n';

const SIDEPANEL_FILTER = i18n.t('constants.sidePanel.filter');
const SIDEPANEL_INBOX = i18n.t('constants.sidePanel.inbox');

export { SIDEPANEL_FILTER, SIDEPANEL_INBOX };
